module.exports = __webpack_public_path__ + "img/urna.7011bbae.svg";